module.exports = __webpack_public_path__ + "img/ic_server3.946e1696.png";